import { memo } from "react";

import ImageLoader from "@Components/ImageLoader";

import type { IActionButtonBanner } from "./ActionButtonBanner";
import { ActionButtonBanner } from "./ActionButtonBanner";

import * as css from "./ImageBanner.module.css";

export type IImageBanner = {
    id: string;
    imageUrl: string;
    altText?: string;
    actionButtons?: IActionButtonBanner;
    isBrandFollowed?: boolean;
};

const ImageBanner = memo(
    (props: IImageBanner) => (
        <div className={css.imageBannerComponent}>
            {props.actionButtons && (
                <ActionButtonBanner
                    id={props.id}
                    isDiscountSaved={props.isBrandFollowed}
                    saveLink={true}
                    saveLinkType="brands"
                    share={props.actionButtons.share}
                />
            )}
            <ImageLoader
                src={props.imageUrl}
                alt={props.altText}
                size={1200}
                srcSetAxis="width"
                lazyLoading
            />
        </div>
    ),
    (prevProps, nextProps) =>
        prevProps.imageUrl === nextProps.imageUrl && prevProps.isBrandFollowed === nextProps.isBrandFollowed,
);

export default ImageBanner;
